/**
 * Normalises an arbitrary thrown value into a stable `errorCause` string for
 * upload tracking. Avoids leaking `"[object Object]"` / `"Error: ..."` into
 * Segment when a non-string is thrown (e.g. from `useDocumentReplaceDmp`).
 */
export function getHttpStatusFromUnknown(error: unknown): number | undefined {
  const status =
    (error as { response?: { status?: number }; status?: number; statusCode?: number })?.response
      ?.status ??
    (error as { status?: number })?.status ??
    (error as { statusCode?: number })?.statusCode;

  return typeof status === 'number' ? status : undefined;
}

export function toUploadErrorCause(error: unknown): string {
  if (typeof error === 'string') return error;
  if (error instanceof Error) return error.message;

  const status = getHttpStatusFromUnknown(error);
  if (status !== undefined) return `HTTP ${status}`;

  return 'Unknown error';
}
